import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { moorestownConfig } from "./data";

export default function MoorestownPage() {
  return <CityPageTemplate config={moorestownConfig} />;
}